import { render, staticRenderFns } from "./PopupHead.vue?vue&type=template&id=5ab11c29&scoped=true"
import script from "./PopupHead.vue?vue&type=script&lang=js"
export * from "./PopupHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab11c29",
  null
  
)

export default component.exports